<template>
  <div class="container-tamanho container-tamanho--custom">
    <label>Tamanho</label>
    <span>
      <span class="container-select">
        <select v-model="productId" @change="$emit('setSize', productId)">
          <option
            :disabled="tamanho.tag_stock === 'UNAVAILABLE'"
            v-for="(tamanho, $t) in tamanhos"
            :key="$t"
            :value="tamanho.id_produto_variacao"
          >
            {{ tamanho.value }}
          </option>
        </select>
        <a
          class="botao-regua-medidas"
          :href="$epecaHubB2c.configJson.FILES_BOUTIQUE_SIZE_GUIDE"
          target="_blank"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="97.875"
            height="97.875"
            viewBox="0 0 97.875 97.875"
          >
            <path
              id="Path_206"
              data-name="Path 206"
              d="M-93.268-262.147l39.046-.239q0-49.306,0-98.967c-.083,0-.227-.008-.37-.008-7.187,0-14.374-.021-21.562.013-5.045.024-10.089.107-15.133.2-1.851.032-1.922.073-1.959,1.938-.061,3.045-.019,6.093-.016,9.14,0,.054.048.107.086.187l9.751-.13c.048,2.647.095,5.218.143,7.842l-10.135.146c.051,3.1.1,6.175.151,9.273l9.841-.135c.048,2.622.1,5.209.144,7.845l-10.134.145c.049,3.1.1,6.16.147,9.273l21.256-.14c.049,2.646.1,5.213.144,7.842l-21.551.145c.049,3.1.1,6.163.147,9.272l9.844-.132c.048,2.637.1,5.222.143,7.844l-10.134.146c.05,3.113.1,6.172.149,9.271l9.844-.132c.048,2.645.095,5.228.142,7.844l-10.134.146C-93.367-269.734-93.318-266.01-93.268-262.147Z"
              transform="translate(-119.31 321.582) rotate(45)"
              fill="#fff"
            />
          </svg>
        </a>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  mounted() {
    this.productId = this.activeProductSize;
  },
  data() {
    return {
      productId: null,
    };
  },
  props: {
    activeProductSize: {
      type: Number,
    },
    tamanhos: {
      type: Array,
      default: [],
    },
  },
};
</script>
<style lang="scss" scoped>
.container-grupo-foto-infos-produto
  .container-infos-produto
  .container-tamanho {
  background-color: #fff;
  border: 1px solid #111;
  display: inline-block;
  font-size: 0.8em;
  padding: 1em 0.75em;
}
.container-grupo-foto-infos-produto
  .container-infos-produto
  .container-tamanho
  label {
  font-weight: bold;
  margin-right: 0.5em;
}
.container-grupo-foto-infos-produto
  .container-infos-produto
  .container-tamanho
  .container-select {
  background-color: #fff;
  padding: 0.15em 0.25em;
}
.container-grupo-foto-infos-produto
  .container-infos-produto
  .container-tamanho
  .container-select
  select {
  background-color: #e6e6e6;
  border: none;
  font-size: 1rem;
  padding: 0.25em;
}
.container-grupo-foto-infos-produto
  .container-infos-produto
  .container-tamanho
  .container-select
  .botao-regua-medidas {
  margin-left: 0.75em;
}
.container-grupo-foto-infos-produto
  .container-infos-produto
  .container-tamanho
  .container-select
  .botao-regua-medidas
  svg {
  height: 16px;
  width: 16px;
}
.container-grupo-foto-infos-produto
  .container-infos-produto
  .container-tamanho
  .container-select
  .botao-regua-medidas
  svg
  * {
  fill: #111;
}
.container-tamanho--custom {
  min-width: 150px;
  .container-select {
    width: 100%;
    display: flex;
    align-items: center;
    select {
      flex-grow: 1;
      display: flex;
    }
  }
}
</style>
